import React, { CSSProperties, ReactNode } from "react";
import styled, { useTheme } from "styled-components";
import EqualColumnsGrid from "common/Grids/EqualColumnsGrid";

interface DirectionFieldsRowProps {
  direction: ReactNode;
  fields: ReactNode;
  columnGap?: number;
  style?: CSSProperties;
}

const DirectionFieldsRow = ({
  direction,
  fields,
  columnGap = 16,
  style,
}: DirectionFieldsRowProps) => {
  const theme = useTheme();
  if (!theme.isNewLook)
    return (
      <EqualColumnsGrid numColumns={3} columnGap={columnGap} style={style}>
        {direction}
        {fields}
      </EqualColumnsGrid>
    );
  return (
    <Row $gap={columnGap} style={style}>
      <Direction $gap={columnGap}>{direction}</Direction>
      <Fields $gap={columnGap}>{fields}</Fields>
    </Row>
  );
};

export default DirectionFieldsRow;

const Row = styled.div<{ $gap: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: 16px ${(p) => p.$gap}px;
`;
const Direction = styled.div<{ $gap: number }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 calc((100% - ${(p) => p.$gap * 2}px) / 3);
`;
const Fields = styled.div<{ $gap: number }>`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: ${(p) => p.$gap}px;
  flex: 2 1 calc((100% - ${(p) => p.$gap * 2}px) * 2 / 3 + ${(p) => p.$gap}px);
  min-width: 0;
`;
